import LegalPage from "@/components/LegalPage";

export function PrivacyPage() {
  return <LegalPage titleKey="privacy.title" contentKey="privacy.content" />;
}